export const READER_TOKEN_KEY = 'readerToken';

export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
export const REGISTER_REQUEST = 'auth/REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'auth/REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'auth/REGISTER_FAILURE';
export const GET_USER_REQUEST = 'auth/GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'auth/GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'auth/GET_USER_FAILURE';
export const LOGOUT = 'auth/LOGOUT';
